import { Type } from 'class-transformer'
import { DeviceType } from './DeviceType'

export class SignInDeviceResponse {
  canSignIn: boolean

  @Type(() => DeviceType)
  devices: DeviceType[]
}
